<div class="user-entry-container project-content-margin">
  <user-menu></user-menu>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
